module.exports = __webpack_public_path__ + "img/rashel-cohen-lan.f04e6a98.jpg";